import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { useContext } from 'react'
import { PreBillsContext } from '../../../../context/PreBillsContext'
import { PreBillsSortBy, PreBillsSortDir } from '../preBillsReducer'

const SortFilter = () => {
  const { filters, setFilters } = useContext(PreBillsContext)

  const handleSortOrderChange = (event: SelectChangeEvent) => {
    const { value } = event.target
    setFilters({ sortBy: value as PreBillsSortBy })
  }

  const handleSortDirectionChange = (event: SelectChangeEvent) => {
    const { value } = event.target
    setFilters({ sortDir: value as PreBillsSortDir })
  }

  return (
    <>
      <FormControl>
        <InputLabel id="sortByLawType">Sort By:</InputLabel>
        <Select label={'Sort By'} onChange={handleSortOrderChange} value={filters.sortBy} sx={{ width: 110 }}>
          <MenuItem value={PreBillsSortBy.Date}>Date</MenuItem>
          <MenuItem value={PreBillsSortBy.MatterId}>Matter #</MenuItem>
          <MenuItem value={PreBillsSortBy.ClientId}>Client #</MenuItem>
        </Select>
      </FormControl>

      <FormControl>
        <InputLabel id="sortByDir">Sort Dir:</InputLabel>
        <Select label={'Sort Dir'} onChange={handleSortDirectionChange} value={filters.sortDir} sx={{ width: 90 }}>
          <MenuItem value={PreBillsSortDir.Asc}>Asc</MenuItem>
          <MenuItem value={PreBillsSortDir.Desc}>Desc</MenuItem>
        </Select>
      </FormControl>
    </>
  )
}

export default SortFilter
